import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "owner-header__title" }
const _hoisted_2 = {
  key: 0,
  class: "page-title"
}
const _hoisted_3 = {
  key: 1,
  class: "page-title"
}
const _hoisted_4 = {
  key: 2,
  class: "page-title"
}
const _hoisted_5 = {
  key: 3,
  class: "page-title"
}
const _hoisted_6 = {
  key: 4,
  class: "page-title"
}
const _hoisted_7 = {
  key: 5,
  class: "page-title"
}
const _hoisted_8 = {
  key: 6,
  class: "page-title"
}
const _hoisted_9 = {
  key: 7,
  class: "page-title"
}
const _hoisted_10 = {
  key: 8,
  class: "page-title"
}
const _hoisted_11 = {
  key: 9,
  class: "page-title"
}
const _hoisted_12 = {
  key: 10,
  class: "page-title"
}
const _hoisted_13 = { class: "viewer-toggle__icon-circle" }
const _hoisted_14 = { class: "viewer-toggle__text" }
const _hoisted_15 = { class: "viewer-toggle__value" }
const _hoisted_16 = {
  key: 0,
  class: "viewer-dropdown"
}
const _hoisted_17 = { class: "viewer-dropdown__header" }
const _hoisted_18 = { class: "viewer-dropdown__search" }
const _hoisted_19 = { class: "viewer-option__avatar viewer-option__avatar--all" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "viewer-option__avatar" }
const _hoisted_22 = { class: "viewer-option__text" }
const _hoisted_23 = { class: "viewer-option__name" }
const _hoisted_24 = { class: "viewer-option__subtitle" }

import { computed, ref, watch, nextTick, onMounted, onBeforeUnmount } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Icon } from "@/components/ui";
import { useUsers } from "@/composables/organization/useUsers";
import { getRoleDisplayName } from "@/utils/enums";
import {
  ACTIVITY_REPORTS_ROUTE,
  BUCKETS_LIST_ROUTE,
  BUCKETS_ROUTE,
  CALL_HISTORY_REPORTS_ROUTE,
  COMPANIES_ROUTE,
  CONTACTS_ROUTE,
  DASHBOARD_ROUTE,
  MEETINGS_ROUTE,
  OPPORTUNITIES_ROUTE,
  REPORTS_ROUTE,
  SETTINGS_ADMIN_ROUTE,
  SETTINGS_AUTO_BUCKET_ROUTE,
  SETTINGS_BILLING_ROUTE,
  SETTINGS_BUY_NEW_NUMBER_ROUTE,
  SETTINGS_CALL_RECORDINGS_ROUTE,
  SETTINGS_CALL_PHONE_NUMBERS_ROUTE,
  SETTINGS_CALL_SETTINGS_ROUTE,
  SETTINGS_DOWNLOADS_ROUTE,
  SETTINGS_INTEGRATIONS_ROUTE,
  SETTINGS_PROFILE_ROUTE,
  TEMPLATES_ROUTE,
  TEMPLATE_FOLDERS_ROUTE,
} from "@/router/routes";

export default /*@__PURE__*/_defineComponent({
  __name: 'OwnerFilterHeader',
  props: {
    route: {},
    account: {}
  },
  setup(__props: any) {

const props = __props;

const vueRoute = useRoute();
const router = useRouter();

const settingsRoutes = [
  SETTINGS_PROFILE_ROUTE,
  SETTINGS_ADMIN_ROUTE,
  SETTINGS_AUTO_BUCKET_ROUTE,
  SETTINGS_BILLING_ROUTE,
  SETTINGS_INTEGRATIONS_ROUTE,
  SETTINGS_DOWNLOADS_ROUTE,
  SETTINGS_CALL_SETTINGS_ROUTE,
  SETTINGS_CALL_RECORDINGS_ROUTE,
  SETTINGS_CALL_PHONE_NUMBERS_ROUTE,
  SETTINGS_BUY_NEW_NUMBER_ROUTE,
];

const ownerFilterRoutes = [
  CONTACTS_ROUTE,
  COMPANIES_ROUTE,
  MEETINGS_ROUTE,
  CALL_HISTORY_REPORTS_ROUTE,
  TEMPLATES_ROUTE,
  TEMPLATE_FOLDERS_ROUTE,
  ACTIVITY_REPORTS_ROUTE,
  BUCKETS_LIST_ROUTE,
  BUCKETS_ROUTE,
  OPPORTUNITIES_ROUTE,
  REPORTS_ROUTE,
];

const rootRef = ref<HTMLElement | null>(null);
const searchInputRef = ref<HTMLInputElement | null>(null);
const searchQuery = ref("");

const currentRouteName = computed(
  () => props.route || ((vueRoute.name as string | undefined) ?? "")
);

const usersParams = computed(() => {
  if (!props.account?.organizationId) return null;
  return { organizationId: props.account.organizationId };
});

const { data: usersData } = useUsers(usersParams);
const users = computed(() => usersData.value ?? []);

const filteredUsers = computed(() => {
  const q = searchQuery.value.trim().toLowerCase();
  if (!q) return users.value;
  return users.value.filter((u: any) => u.fullName?.toLowerCase().includes(q));
});

const selectedOwner = ref<"all" | any | null>(null);
const isDropdownOpen = ref(false);

const selectedOwnerKey = computed(() => {
  if (selectedOwner.value === "all") return "all";
  return selectedOwner.value?.id ?? "all";
});

const currentOwnerLabel = computed(() => {
  if (selectedOwnerKey.value === "all") return "All Users";
  return selectedOwner.value?.fullName || "All Users";
});

const showOwnerFilter = computed(() => ownerFilterRoutes.includes(currentRouteName.value));

const selectOwnerAndUpdateQuery = (owner: "all" | any) => {
  selectedOwner.value = owner;
  const ownerValue = owner === "all" ? "all" : owner.id;
  router.replace({
    query: {
      ...vueRoute.query,
      owner: ownerValue,
    },
  });
};

const handleSelectAll = () => {
  selectOwnerAndUpdateQuery("all");
  isDropdownOpen.value = false;
  searchQuery.value = "";
};

const handleSelectUser = (user: any) => {
  selectOwnerAndUpdateQuery(user);
  isDropdownOpen.value = false;
  searchQuery.value = "";
};

const syncSelectedOwnerFromQuery = () => {
  const ownerParam = vueRoute.query.owner as string | undefined;

  if (ownerParam === "all") {
    selectedOwner.value = "all";
    return;
  }

  if (ownerParam) {
    const match = users.value.find((u: any) => u.id === ownerParam);
    if (match) {
      selectedOwner.value = match;
      return;
    }
  }

  selectedOwner.value = props.account || null;
};

const toggleDropdown = () => {
  if (!showOwnerFilter.value) return;
  isDropdownOpen.value = !isDropdownOpen.value;
  if (!isDropdownOpen.value) searchQuery.value = "";
};

watch(isDropdownOpen, (open) => {
  if (open) nextTick(() => searchInputRef.value?.focus());
});

const handleClickOutside = (event: MouseEvent) => {
  if (!isDropdownOpen.value) return;
  if (rootRef.value && !rootRef.value.contains(event.target as Node)) {
    isDropdownOpen.value = false;
    searchQuery.value = "";
  }
};

const getInitials = (fullName?: string) => {
  if (!fullName) return "";
  const parts = fullName.trim().split(/\s+/);
  const initials = parts.slice(0, 2).map((p) => p[0]?.toUpperCase() || "");
  return initials.join("");
};

const getRoleLabel = (role?: string) => {
  if (!role) return "";
  return getRoleDisplayName(role);
};

watch(
  () => props.account,
  (newAccount) => {
    if (!newAccount) return;
    if (!vueRoute.query.owner && !selectedOwner.value) {
      selectOwnerAndUpdateQuery("all");
    }
  },
  { immediate: true }
);

watch(
  () => vueRoute.query.owner,
  () => {
    syncSelectedOwnerFromQuery();
  }
);

watch(users, () => {
  if (vueRoute.query.owner) {
    syncSelectedOwnerFromQuery();
  }
});

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
  syncSelectedOwnerFromQuery();
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "owner-header",
    ref_key: "rootRef",
    ref: rootRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      (currentRouteName.value === _unref(DASHBOARD_ROUTE))
        ? (_openBlock(), _createElementBlock("h4", _hoisted_2, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("strong", null, "Dashboard", -1)
          ]))]))
        : (currentRouteName.value === _unref(CONTACTS_ROUTE))
          ? (_openBlock(), _createElementBlock("h4", _hoisted_3, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("strong", null, "Contacts", -1)
            ]))]))
          : (currentRouteName.value === _unref(COMPANIES_ROUTE))
            ? (_openBlock(), _createElementBlock("h4", _hoisted_4, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("strong", null, "Accounts", -1)
              ]))]))
            : (currentRouteName.value === _unref(MEETINGS_ROUTE))
              ? (_openBlock(), _createElementBlock("h4", _hoisted_5, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("strong", null, "Meetings", -1)
                ]))]))
              : (currentRouteName.value === _unref(BUCKETS_LIST_ROUTE))
                ? (_openBlock(), _createElementBlock("h4", _hoisted_6, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("strong", null, "Buckets", -1)
                  ]))]))
                : (
          currentRouteName.value === _unref(TEMPLATES_ROUTE) || currentRouteName.value === _unref(TEMPLATE_FOLDERS_ROUTE)
        )
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_7, [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("strong", null, "Templates", -1)
                    ]))]))
                  : (currentRouteName.value === _unref(ACTIVITY_REPORTS_ROUTE))
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_8, [...(_cache[9] || (_cache[9] = [
                        _createElementVNode("strong", null, "Activity Report", -1)
                      ]))]))
                    : (currentRouteName.value === _unref(CALL_HISTORY_REPORTS_ROUTE))
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_9, [...(_cache[10] || (_cache[10] = [
                          _createElementVNode("strong", null, "Call History", -1)
                        ]))]))
                      : (currentRouteName.value === _unref(OPPORTUNITIES_ROUTE))
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_10, [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("strong", null, "Opportunities", -1)
                          ]))]))
                        : (currentRouteName.value === _unref(REPORTS_ROUTE))
                          ? (_openBlock(), _createElementBlock("h4", _hoisted_11, [...(_cache[12] || (_cache[12] = [
                              _createElementVNode("strong", null, "Reports", -1)
                            ]))]))
                          : (settingsRoutes.includes(currentRouteName.value))
                            ? (_openBlock(), _createElementBlock("h4", _hoisted_12, [...(_cache[13] || (_cache[13] = [
                                _createElementVNode("strong", null, "Settings", -1)
                              ]))]))
                            : _createCommentVNode("", true)
    ]),
    (showOwnerFilter.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "owner-header__viewer",
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "viewer-toggle",
            onClick: toggleDropdown
          }, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_unref(Icon), {
                icon: "majesticons:users-line",
                class: "viewer-toggle__icon"
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "viewer-toggle__label" }, "Viewing:", -1)),
              _createElementVNode("span", _hoisted_15, _toDisplayString(currentOwnerLabel.value), 1)
            ]),
            _createVNode(_unref(Icon), {
              icon: isDropdownOpen.value ? 'mdi:chevron-up' : 'mdi:chevron-down',
              class: "viewer-toggle__chevron"
            }, null, 8, ["icon"])
          ]),
          (isDropdownOpen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_unref(Icon), {
                    icon: "uil:user",
                    class: "viewer-dropdown__header-icon"
                  }),
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "viewer-dropdown__header-text" }, "Select user to view their data", -1))
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_unref(Icon), {
                    icon: "mdi:magnify",
                    class: "viewer-dropdown__search-icon"
                  }),
                  _withDirectives(_createElementVNode("input", {
                    ref_key: "searchInputRef",
                    ref: searchInputRef,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                    type: "text",
                    class: "viewer-dropdown__search-input",
                    placeholder: "Search users...",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                  }, null, 512), [
                    [_vModelText, searchQuery.value]
                  ])
                ]),
                (filteredUsers.value.length === users.value.length)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: _normalizeClass(["viewer-option", { 'viewer-option--selected': selectedOwnerKey.value === 'all' }]),
                      onClick: handleSelectAll
                    }, [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_unref(Icon), {
                          icon: "majesticons:users-line",
                          class: "viewer-option__avatar-icon"
                        })
                      ]),
                      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "viewer-option__text" }, [
                        _createElementVNode("span", { class: "viewer-option__name" }, "All Users"),
                        _createElementVNode("span", { class: "viewer-option__subtitle" }, "View combined data")
                      ], -1)),
                      (selectedOwnerKey.value === 'all')
                        ? (_openBlock(), _createBlock(_unref(Icon), {
                            key: 0,
                            icon: "mdi:check",
                            class: "viewer-option__check-icon"
                          }))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUsers.value, (user) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: user.id,
                    type: "button",
                    class: _normalizeClass(["viewer-option", { 'viewer-option--selected': selectedOwnerKey.value === user.id }]),
                    onClick: ($event: any) => (handleSelectUser(user))
                  }, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString(getInitials(user.fullName)), 1),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, _toDisplayString(user.fullName), 1),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(getRoleLabel(user.role)), 1)
                    ]),
                    (selectedOwnerKey.value === user.id)
                      ? (_openBlock(), _createBlock(_unref(Icon), {
                          key: 0,
                          icon: "mdi:check",
                          class: "viewer-option__check-icon"
                        }))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_20))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})